import Divider from '@mui/material/Divider';
export default Divider;
export * from '@mui/material/Divider';
